export const dataTestIds = {
  chargerPage: {
    // Charger info
    chargerName: 'charger-name',
    chargingStatus: 'charging-status',

    // Action buttons
    startChargingButton: 'start-charging-button',
    stopChargingButton: 'stop-charging-button',
    receiptButton: 'receipt-button',

    // Session info
    successCheckDiv: 'success-check',
    totalAmountLabel: 'total-amount-label',

    completedSessionCostLabel: 'completed-session-cost-label',
  },

  loginPage: {
    loginToStart: 'login-to-start',
    signUpButton: 'sign-up-button',
  },

  accountPage: {
    accountHeader: 'account-header',
  },

  otpPage: {
    enterVerificationHeader: 'enter-verification-header',
    enterTheCodeYouReceived: 'enter-the-code-you-received',
    otpInput: 'otp-input',
  },

  registerPage: {
    acceptTermsAndConditions: 'accept-terms-and-conditions',
    privacyPolicy: 'privacy-policy',
    termsOfService: 'terms-of-service',
    returnToLogin: 'return-to-login',
    nextButtonRegister: 'next-button-register',
  },
} as const;

export type DataTestIds = typeof dataTestIds;
export type PageSelector<T extends keyof DataTestIds> = DataTestIds[T];
